import { lazy } from 'react'

// Sidene i App.jsx lastes når de åpnes, ikke alle ved oppstart. Fram til
// 24.10.2026 lå alle de rundt 110 sidene i én fil på 3,3 MB (863 kB gzip),
// som hver side — også TV-skjermene og de offentlige sidene — måtte laste og
// tolke før noe vistes.
//
// Prisen er at en fane som ble åpnet før en deploy, ber om filnavn som ikke
// finnes lenger: Vercel serverer bare den nye utrullingen, og omskrivingen i
// vercel.json svarer da med index.html i stedet for JavaScript. Da lastes
// siden på nytt én gang, så brukeren får den nye versjonen i stedet for en
// feilside. Feiler den igjen innen et minutt, er det ikke en deploy, og
// feilen går videre til ErrorBoundary. Uten sessionStorage (en TV i privat
// modus) lastes den aldri på nytt, så ingenting kan gå i løkke.

const NOKKEL = 'pulse.side.omlastet'
const MINST_MELLOM_MS = 60_000

export function skalLasteOm({ sist, naa }) {
  return sist == null || naa - sist >= MINST_MELLOM_MS
}

function lesSist() {
  const verdi = Number(window.sessionStorage.getItem(NOKKEL))
  return Number.isFinite(verdi) && verdi > 0 ? verdi : null
}

export function lastSide(importer) {
  return lazy(() => importer().catch((feil) => {
    try {
      const naa = Date.now()
      if (!skalLasteOm({ sist: lesSist(), naa })) throw feil
      window.sessionStorage.setItem(NOKKEL, String(naa))
    } catch {
      throw feil
    }
    window.location.reload()
    // Hold Suspense til omlastingen tar over, i stedet for å vise feilen.
    return new Promise(() => {})
  }))
}
